export default {
  auto: 'Automatický',
  signals: 'Signály',
  axes: 'Osi',
  axesHeader: {
    displayName: 'Popis osi',
    chartScaleType: 'Typ osi',
    position: 'Poloha osi',
    limitMin: 'Minimálny limit',
    limitMax: 'Maximálny limit',
    defaultUnitOfMeasure: 'Jednotka merania',
    signalCount: 'Počet signálov',
    delete: '',
  },
  deleteAxisConfirmation: {
    title: 'Odstrániť os',
    message: 'Táto os obsahuje {count} signálov. Všetky tieto signály budú tiež odstránené. Naozaj ich chcete odstrániť?',
  },
};
